import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { useToggle } from '@hooks/useToggle';

import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';
import { configs } from '@constants/configs/configs';
import { preventerTools } from '@utils/tools/preventerTools';

import { changeData } from '@actions/ssap/ssapActionCreators';

import CheckboxForSettings from '../inputs/CheckboxForSettings';
import RegularInputForSettings from '../inputs/RegularInputForSettings';
import DropdownForSettings from '../inputs/DropdownsForSettings';
import Manager from './Manager';

const Settings = props => {

    const {
        currentLocation,
        data
    } = props;

    const [ areSettingsShown, toggleVisibility ] = useToggle(false);

    const settings = localStorageHyperDashboardTools.settings;

    const getInitialSettings = () => {
        localStorageHyperDashboardTools.setInitialSettings();
        areSettingsShown && toggleVisibility();
    };

    const getSettings = () => {

        if(!settings) {
            return null;
        }

        return Object.entries(settings).map(setting => {

            const [ , 
                { 
                    text: settingNameForUi, 
                    outputType, 
                    shouldBeShown = undefined, 
                    shouldNotBeShown = undefined,
                    modifier
                } 
            ] = setting;

            if(![ shouldBeShown, shouldNotBeShown ].every(v => v === undefined)) {
                if(preventerTools.provideArray(shouldNotBeShown).some(path => path === currentLocation)) {
                    return null;
                }

                if(!preventerTools.provideArray(shouldBeShown).some(path => path === currentLocation)) {
                    return null;
                }
            }

            const handleInputChange = (e, isUpdateSkipped = undefined) => {

                const {
                    name,
                    value,
                    checked
                } = e.target;

                let valueForSave = '';

                switch(outputType) {
                    case 'number':
                        if(name === 'maxAchievedPage') {
                            const newState = { ...data };

                            props.actions.changeData({
                                ...newState,
                                maxAchievedPage: Number(value)
                            });
                            if(!isUpdateSkipped) {
                                valueForSave = Number(value);
                                localStorageHyperDashboardTools.setValueByPropName(name, valueForSave);
                            }
                            return null;
                        }
                        valueForSave = Number(value);
                        break;
                    case 'string':
                    case 'object':
                        valueForSave = String(value); break;
                    case 'boolean':
                        valueForSave = Boolean(checked); break;
                }

                localStorageHyperDashboardTools.setValueByPropName(name, valueForSave);
            };

            const getInput = setting => {

                let [
                    settingName,
                    {
                        value,
                        inputType,
                        options,
                        switchers
                    }
                ] = setting;



                switch(inputType) {
                    case 'regularInput':
                        return (
                            <RegularInputForSettings
                                { ...{
                                    value,
                                    settingName,
                                    switchers,
                                    handleInputChange
                                } }
                            />
                        );

                    case 'dropdown':
                        return (
                            <DropdownForSettings 
                                { ...{  
                                    value,
                                    settingName,
                                    handleInputChange,
                                    options,
                                    modifier,
                                    settings
                                } } 
                            />
                        );
                    case 'checkbox':
                        return (
                            <CheckboxForSettings
                                { ...{
                                    value,
                                    settingName,
                                    handleInputChange
                                } }
                            />
                        );
                }
            };

            return (
                <span key={settingNameForUi} style={{ display: 'inline-block', marginRight: '10px' }}>
                    <span>{ settingNameForUi }</span> &nbsp;
                    {
                        getInput(setting)
                    }
                </span>
            );
        }).filter(i => i);
    };

    const defaultButtonStyle = {
        padding: '3px',
        backgroundColor: '#00a6d2',
        outline: 'none',
        borderRadius: '3px',
        cursor: 'pointer',
        marginRight: '20px',
        color: 'black'
    };



    return (
        <div style={{
            padding: '10px',
            backgroundColor: areSettingsShown ? 'rgb(0, 0, 0, 0.15)' : 'initial',
            borderRadius: '5px',
            position: 'relative'
        }}>
            <span
                style={{
                    fontWeight: 'bold',
                    fontSize: '1.5rem',
                    marginLeft: '10px'
                }}
            >
                {
                    configs.ENV.DEVELOPMENT ? 'Current UI codebase' : __SNAPSHOT__
                }
            </span>
            <span
                style={{
                    position: 'absolute',
                    left: '230px',
                    top: 0
                }}
            >
                <button
                    onClick={() => toggleVisibility()}
                    style={{
                        ...defaultButtonStyle,
                        backgroundColor: areSettingsShown ? 'rgb(134, 196, 140)' : '#00a6d2'
                    }}
                >
                    { areSettingsShown ? 'Hide settings' : 'Show settings' }
                </button>
                <button
                    onClick={() => getInitialSettings()}
                    style={{
                        ...defaultButtonStyle
                    }}
                >
                Initial Settings
                </button>
                <Manager
                    { ...{
                        isContentSkipped: true,
                        buttons: {
                            ReduxStore: false
                        }
                    } }
                />
            </span>
            
            <div style={{ marginLeft: '5px' }}>
                {
                    areSettingsShown && getSettings()
                }
            </div>
        </div>
    );
};

const mapStateToProps = state => ({
    data: state.ssap.data
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        changeData
    }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Settings);
